<template>
    <div>
        <refresh :on-refresh="refresh" :refreshing="refreshing"></refresh>
        <loading :loading="loading"></loading>
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6" >
                <Logo :logo-type="theType" />
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6" v-if="noMessages">
                You do not have any {{typeDesc}}.
            </div>
            <div class="col-11 col-xs-11 col-md-6" v-else>
                <div v-for="sender in senders" v-bind:key="sender.id" class="u-mt1 u-mb1">
                    <div class="call-container" :class="sender.unread ? '-new' : '-viewed'" v-on:click="viewSender(sender.id)">
                        <div class="call-avatar-container">
                            <ion-avatar class="call-avatar">
                                <img :src="sender.avatar" v-if="sender.avatar">
                                <img src="../../assets/ghost-avatar-white-thumb.png" class="dark-img" v-else>
                            </ion-avatar>
                        </div>
                        <div class="call-info">
                            <div class="call-title">
                                {{sender.name}}
                            </div>
                            <div class="call-date">
                                Last message {{dateFormat(sender.latest.send_at, 'Do MMMM YYYY')}}
                            </div>
                        </div>
                        <div class="call-meta">
                            <div v-if="sender.unread" class="call-new"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 col-xs-12 col-md-4">
                <div class="router-nav u-mt2 u-mb2">
                    <ion-button shape="round" expand="full" v-on:click="back()">Return</ion-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {auth} from '@/mixins/auth';
import {userdetails} from '@/mixins/userdetails';
import {formatting} from '@/mixins/formatting';
import ReturnHome from '@/components/ReturnHome.vue';
import Refresh from '@/components/Refresh.vue';
import Loading from '@/components/Loading.vue';
import Logo from '@/components/Logo.vue';
import _ from 'lodash';

export default {
    name: 'messagelist',
    mounted : function () {
        this.getSenders();
        this.showNotificationMessage();
    },
    mixins : [auth, userdetails, formatting],
    components : {
        ReturnHome, Logo, Refresh, Loading
    },
    data : function () {
        return {
            theType : 'text',
            senders : [],
            loading  : false,
            refreshing : false
        };
    },
    computed : {
        typeTitle : function () {
            if (this.theType == 'audio') { return 'Calls'; }
            if (this.theType == 'video') { return 'Videos'; }
            if (this.theType == 'image') { return 'Gallery'; }
            return 'Messages';
        },
        typeDesc : function () {
            if (this.theType == 'audio') { return 'calls'; }
            if (this.theType == 'video') { return 'videos'; }
            if (this.theType == 'image') { return 'photos'; }
            return 'messages';
        },
        noMessages : function () {
            return _.size(this.senders) == 0;
        }
    },
    methods : {
        refresh : function () {
            this.refreshing = true;
            this.page = 1;
            this.getSenders();
        },
        hideLoading : function () {
            this.loading = false;
            this.refreshing = false;
        },
        getSenders : function () {
            let self = this;
            this.loading = true;
            this.axios.get(this.api + 'messages/inbox/' + this.theType + '/senders')
                .then(response => {
                    if (self.refreshing) {
                        self.senders = [];
                        self.refreshing = false;
                    }
                    self.senders = response.data;
                    self.hideLoading();
                })
                .catch(error => {
                    console.error('Error getting messages', error);
                    self.hideLoading();
                });
        },
        viewSender : function (id) {
            this.$router.push({name : 'messagepage', params : {id : id}});
        },
        back : function () {
            this.$router.push({name : 'home'});
        },
        showNotificationMessage : function () {
            let self = this;
            if (localStorage.getItem('ghost.pushmessage')) {
                let notification = JSON.parse(localStorage.getItem('ghost.pushmessage'));
                if (notification.type && notification.type == 'message') {
                    if (notification.from) {
                        // load the page for that person
                        this.$router.push({name : 'messagepage', params : {id : notification.from}});
                    }
                }
            }
        }
    }
}
</script>